import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Actions from "../../../Actions";
import logger from "../../../utils/LoggerFrontend";
import { TextInput } from "../../../Components/Form";
import { Button } from "../../../Components/Button";
import { useTranslation } from "react-i18next";
import { Group } from "../../../Components/Layout";

const Wrapper = styled.div`
  height: auto;
  margin-bottom: 4rem;
`;

const maxLen = 200;

export const MhmIntegration = ({
  organization: {
    integrations: { mhm },
    name
  },
  campaignData,
  campaignId,
  onSaveIntegration
}) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState(campaignData?.integrations?.mhm?.email);

  logger.log("MhmIntegration", "called", {
    mhm,
    name,
    campaignData
  });

  useEffect(() => {
    const unsubscribeUpdateCampaign = Actions.updateCampaignWithId.completed.listen(() => {
      Actions.addNotification("Synchronisierung erfolgreich");
    });

    const unsubscribeUpdateCampaignFailed = Actions.updateCampaignWithId.failed.listen((error) => {
      logger.log("error:MhmIntegration", "unable to connect with Mhm job", {
        error
      });

      Actions.addNotification("Synchronisierung nicht erfolgreich", "error");
    });

    return () => {
      unsubscribeUpdateCampaign();
      unsubscribeUpdateCampaignFailed();
    };
  }, [mhm]);

  const changeEmail = (e) => {
    setEmail(e.target.value);
  };

  const saveEmail = () => {
    const update = {
      integrations: { mhm: { ...mhm, email } }
    };
    Actions.updateCampaignWithId(campaignId, update);
    onSaveIntegration && onSaveIntegration(update);
  };

  const invalid =
    email?.length === 0 || !email?.includes("@") || !email?.includes(".") || email?.length > maxLen;

  const noChange = email === campaignData?.integrations?.mhm?.email;

  return (
    <Wrapper>
      <h3>{name} - MHM</h3>
      <Group width="100%" gap="1rem" align="flex-end" margin="2rem 0 0 0">
        <TextInput label="Email" value={email} onChange={changeEmail} invalid={invalid} />
        <Button text={t("Save")} onClick={saveEmail} disabled={invalid || noChange} />
      </Group>
    </Wrapper>
  );
};
